// components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-charcoal py-12 px-8">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid md:grid-cols-[2fr_1fr_1fr] gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <div className="w-9 h-9 bg-teal rounded-lg flex items-center justify-center">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round">
                  <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>
                </svg>
              </div>
              <div>
                <h2 className="text-white text-base font-serif">SRM Diagnostic Center</h2>
                <p className="text-[0.68rem] text-[#5a8580] tracking-wider uppercase mt-0.5">Dehradun · Uttarakhand</p>
              </div>
            </div>
            <p className="text-sm text-[#7aaea9] leading-relaxed">Accurate, affordable, and timely pathology services for the people of Dehradun. Your health is our priority.</p>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">Our Services</a></li>
              <li><a href="#tests" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">Test Menu</a></li>
              <li><a href="#process" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">How It Works</a></li>
              <li><a href="#why" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">Why Choose Us</a></li>
              <li><a href="#contact" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">Contact & Booking</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">Sevla Kala, GMS Road</a></li>
              <li><a href="#" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">Near Keshav Medical Center</a></li>
              <li><a href="#" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">Dehradun, Uttarakhand</a></li>
              <li><a href="#" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">+91 91493 22973</a></li>
              <li><a href="#" className="text-[#7aaea9] text-sm hover:text-[#7dd8cf] transition-colors">7:00 AM – 8:00 PM Daily</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-5 flex flex-col md:flex-row justify-between items-center text-sm text-[#5a8580]">
          <p>© SRM Diagnostic Center, Dehradun. All rights reserved.</p>
          <p>Designed for healthcare excellence.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;